import { withStyles, Switch } from '@material-ui/core'
const pxToRem = (px, oneRemPx = 16) => `${px / oneRemPx}rem`
const spacing = 8
const size = pxToRem(28)
const width = pxToRem(52 + 2 * spacing)
const borderWidth = 2
const height = `calc(${size} + ${borderWidth * 2}px + ${pxToRem(2 * spacing)})`

export const ESwitch = withStyles((theme) => ({
  root: {
    width,
    height,
    padding: pxToRem(spacing),
    margin: 0,
  },
  switchBase: {
    padding: 3.5,
    top: pxToRem(spacing),
    left: pxToRem(spacing),
    color: theme.palette.grey[100],
    '&$checked': {
      transform: `translateX(calc(${width} - ${size} - ${borderWidth * 2}px - ${pxToRem(2 * spacing)}))`,
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#0CB458',
        opacity: 1,
        border: 'none',
      },
    },
  },
  thumb: {
    width: pxToRem(24),
    height: pxToRem(24),
  },
  track: {
    borderRadius: 40,
    border: `2px solid ${theme.palette.grey[100]}`,
    borderWidth,
    backgroundColor: theme.palette.common.white,
    opacity: 1,
  },
  checked: {},
}))(Switch)
